import { h } from 'preact';
import { sortObjectByOrder } from 'utils/utils';
import { filterUnusedPages } from 'utils/bolt/header';
import * as BaseComp from 'components/bolt/header/headerExpanded.js';



export default class HeaderExpanded extends BaseComp.default {
	constructor(props) {
		super(props);
		const isDesktopSize = this.props?.client?.isDesktopSize;
		const uarNav = this.props?.appData?.header?.uarHeader?.nav;
		if (!isDesktopSize && uarNav) {
			this.updateNavLinks('add');
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevProps?.client?.isDesktopSize !== this.props?.client?.isDesktopSize) {
			if (this.props.client.isDesktopSize) {
				this.updateNavLinks('remove');
			} else {
				this.updateNavLinks('add');
			}
		}
	}

	updateNavLinks(action) {
		this.originalNavItems = this.originalNavItems || this.navItems;
		const uarNav = this.props?.appData?.header?.uarHeader?.nav;
		const uarNavItems = sortObjectByOrder(uarNav);
		if (action === 'add') {
			this.navItems = this.originalNavItems.concat(uarNavItems);
		} else {
			this.navItems = this.originalNavItems;
		}
		this.filteredNavItems = filterUnusedPages(this.props, this.navItems);
		this.standardLinks = this.filteredNavItems.filter(item => item && item.linkType === 'primary');
		this.featuredLinks = this.navItems.filter(item => item && item.linkType === 'secondary');
		this.isSplitHeader = !!this.featuredLinks.length;
	}

	render(props) {
		const base = super.render(props);
		const isDesktopSize = this.props.client.isDesktopSize;
		const hasUarHeader = this.props?.appData?.header?.uarHeader;

		if (isDesktopSize && hasUarHeader && props.navOpen) {
			base.attributes.style = {
				...base.attributes.style,
				paddingTop: '134px'
			};
		}
		return base;
	}
}
